import { useState, useCallback } from 'react'
import { showNotification } from '@/utils/notifications'
import { isEmpty } from 'lodash'

export const useFormValidation = (schema) => {
    const [formErrors, setFormErrors] = useState({})

    const validateForm = useCallback(
        (data, silent = false) => {
            const result = schema.safeParse(data)
            const fieldErrors = {}

            if (!result.success) {
                result.error.errors.forEach((e) => {
                    fieldErrors[e.path[0]] = e.message
                })

                setFormErrors(fieldErrors)

                // Show notification when there are errors and not silent
                if (!silent) {
                    const firstErrorMessage = result.error.errors?.[0]?.message
                    const message = firstErrorMessage
                        ? `Please fix the errors before proceeding. ${firstErrorMessage}`
                        : 'Please fix the errors before proceeding.'
                    showNotification(message, 'error', 5000, null, null, true, true)
                    return false
                }

                return false
            }

            setFormErrors(fieldErrors)
            return true
        },
        [schema],
    )

    const clearErrors = useCallback(() => {
        setFormErrors({})
    }, [])

    const hasErrors = !isEmpty(formErrors)

    return {
        formErrors,
        validateForm,
        clearErrors,
        hasErrors,
        setFormErrors,
    }
}
